import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorB5ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: true;
};

export class ResumeIndicatorB5ByHealthTeamData {
	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalProcedures: number = 0;
	totalProceduresLinked: number = 0;
	totalPreventProcedures: number = 0;
	totalPreventProceduresLinked: number = 0;
}

export async function getResumeIndicatorB5ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorB5ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorB5ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b5/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorB5ByHealthTeamData>();
}
